__webpack_require__.p = "/trade-dashboard/";